// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-message-box{width:420px}.el-message-box .el-message-box__content{max-height:300px}", ""]);
// Exports
module.exports = exports;
